export const usaName = 'United States';
export const canadaName = 'Canada';

export type Country = typeof usaName | typeof canadaName;

export const countries = [
  {
    name: usaName,
    abbreviation: 'US',
  },
  {
    name: canadaName,
    abbreviation: 'CA',
  },
];
